import {Injectable} from '@angular/core';
import {Country} from '../../shared/models/country';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Address} from '../../shared/models/address';

@Injectable({
  providedIn: 'root'
})
export class DhlMapperService {
  dhlDeliveryTime = undefined ;
  dlhErrorType = undefined ;
  typeAddressDhl = undefined ;
  constructor() {
  }

  formToDHL(orderAddress: Address, expeditionDate: string, countries: Country[] ): Object {
    let newCountryCode;
    newCountryCode = _.find(countries, gr => gr.name === orderAddress.countryForm.name);
    if (newCountryCode) {
      newCountryCode = newCountryCode.code;
    }
    if (newCountryCode === 'bl') {
      newCountryCode = 'xy';
    }

    return {
        'RateRequest': {
          'Request': null,
          'ClientDetails': null,
          'RequestedShipment': {
            'DropOffType': 'REQUEST_COURIER',
            'ShipTimestamp': moment(expeditionDate).format(),
            'UnitOfMeasurement': 'SU',
            'Content': 'DOCUMENTS',
            'PaymentInfo': 'DAP',
            'NextBusinessDay': 'Y',
            'Account': '271569280',
            'Billing': null,
            'SpecialServices': null,
            'Ship': {
              'Shipper': {
                'StreetLines': 'boulevard international',
                'StreetLines2': '',
                'StreetLines3': '',
                'StreetName': '',
                'StreetNumber': '55 K',
                'City': 'Brussels',
                'PostalCode': '1070',
                'CountryCode': 'BE',
              },
              'Recipient': {
                'StreetLines': orderAddress.line1,
                'StreetLines2': orderAddress.line2,
                'StreetLines3': orderAddress.line3,
                'StreetName': '',
                'StreetNumber': '',
                'City': orderAddress.city,
                'PostalCode': orderAddress.zip,
                'CountryCode': newCountryCode,
              }
            },
            'Packages': {
              'RequestedPackages': {
                '@number': '1',
                'Weight': {
                  'Value': 9.0
                },
                'Dimensions': {
                  'Length': 20.0,
                  'Width': 15.0,
                  'Height': 10.0
                }
              }
            },
            'LandedCost': null
          }
        }
    }
  }
  /* tslint:disable */
  DBToVue(message): void {
  /* tslint:enable */
    this.dhlDeliveryTime = undefined ;
    this.dlhErrorType = undefined ;
    this.typeAddressDhl = undefined ;
    if (message) {
      if ( message.resp.data.RateResponse.Provider[0].Notification[0].Message !== null ) {
        const notification = message.resp.data.RateResponse.Provider[0].Notification[0].Message;

        if ( notification.search('country') !== -1) {
          this.dlhErrorType = 'country';
        }
        if ( notification.search('Postcode') !== -1) {
          this.dlhErrorType = 'zip';
        }
        if ( notification.search('location') !== -1) {
          this.dlhErrorType = 'city';
        }
        if ( notification.search('Postcode') === -1 &&
             notification.search('country') === -1 && notification.search('location') === -1) {
          this.dlhErrorType = 'other';
        }

      }

      if (message.resp.data.RateResponse.Provider[0].Service) {
        this.dhlDeliveryTime = message.resp.data.RateResponse.Provider[0].Service[0].DeliveryTime;
      }
      this.typeAddressDhl = message.resp.type;

    }
  }
  getDhlMessageError(): string {
    return this.dlhErrorType;
  }
  getDhlAddressType(): string {
    return this.typeAddressDhl;
  }
  getDhlDeliveryDate(): string {
    return  this.dhlDeliveryTime;
  }
  resetData(): void {
    this.dhlDeliveryTime = undefined ;
    this.dlhErrorType = undefined ;
    this.typeAddressDhl = undefined ;
  }
}
